import { SxProps, Theme } from '@mui/material/styles';

export const activityLogsStyles: Record<string, SxProps<Theme>> = {
  container: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    gap: 2,
    pt: 1,
    maxHeight: '400px',
    overflowY: 'auto',
  },
  logItem: {
    border: '1px solid #E0E0E0',
    borderRadius: 2,
    padding: 2,
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    backgroundColor: '#FAFAFA',
  },
  description: {
    fontSize: '0.85rem',
    fontWeight: 500,
  },
  meta: {
    display: 'flex',
    justifyContent: 'space-between',
    color: '#666',
    alignItems: 'center',
  },
  userInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
  },
  user: {
    fontSize: 'small',
  },
  time: {
    fontSize: 'small',
    fontStyle: 'italic',
  },
  noLogsText: {
    fontSize: '0.9rem',
    color: '#999',
    textAlign: 'center',
  },
};
